import { Identifier, Timestamp } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

// /api/v2/notifications?limit=9

export interface Notification {
  conversation: Identifier;
  nickname: string;
  read: boolean;
  string: string;
  time: Timestamp;
  type: string;
  user_id: Identifier;
  userimage: string;
  link: string;
}

export const fetchNotifications = async (): Promise<Notification[]> => {
  const response = await api.get(`/api/v2/notifications`, {
    params: {
      limit: 50,
    },
  });
  return response.data;
};

interface NotificationParams {
  start: Timestamp;
  end?: Timestamp;
}
export const readNotification = async ({ start, end }: NotificationParams) => {
  const params = { timestamp: start, end };
  await api.get('/api/v2/notifications/mark_read', { params });
};

/*
// notifications
$("body").on(
  "click",
  ".notification-center .notification, .notification-center .notification a",
  function () {
    var isLink = $(this).is("a");
    var notification = isLink ? $(this).closest(".notification") : $(this);
    var timestamp = notification.data("timestamp");
    var count = $(".notification-bubble");
    var link = null;

    if (isLink) {
      link = $(this);
      if (!e.metaKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }

    $.get(
      "/user_notifications/mark_read",
      { timestamp: timestamp },
      function () {
        if (isLink) {
          if (!e.metaKey) window.location = link.attr("href");
        } else {
          if (parseInt(count.text()) == 1)
            count.removeClass("with-notifications");

          notification.addClass("read");
          var curCount = parseInt(count.text());
          count.html(curCount > 1 ? curCount - 1 : "&nbsp;");
        }
      },
    );
  },
);

$("body").on("click", ".notification-center .mark-read", function () {
  var notifications = $(".notification-center .notification");
  var first = notifications.first();
  var last = notifications.last();

  $.get(
    "/user_notifications/mark_read",
    {
      end: first.data("timestamp"),
      timestamp: last.data("timestamp"),
      date: new Date().getTime(),
    },
    function () {
      notifications.addClass("read");
      $(".notification-bubble")
        .removeClass("with-notifications")
        .html("&nbsp;");
    },
  );
  });*/
